import type { ContactPerson } from '@interfaces/contact.interface';

import { mockDb } from '../mock-db';

export function getContactPersonsMock(): ContactPerson[] {
  return mockDb.getContactPersons();
}

export function getContactPersonByIdMock(id: string): ContactPerson | undefined {
  return mockDb.getContactPersonById(id);
}

export function createContactPersonMock(data?: Partial<ContactPerson>): ContactPerson {
  const base = mockDb.contacts[0];
  return { ...base, id: `contact-${Date.now()}`, ...data };
}

export function updateContactPersonMock(id: string, data: Partial<ContactPerson>): ContactPerson {
  const existing = mockDb.getContactPersonById(id);
  const base = existing ?? mockDb.contacts[0];
  return { ...base, id, ...data };
}

export function deleteContactPersonMock(): { success: boolean } {
  return { success: true };
}
